import React from 'react';
import TemplateLayout from '../layouts/templates';
import Form404 from '../pages/form-404';

class Templates extends React.Component {
  render() {
    return (
      <Form404 {...this.props}>
        <TemplateLayout location={this.props.location} />
      </Form404>
    );
  }
}

export default Templates;
